var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPositionYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.67645 9.0957C2.67645 5.44447 5.34782 2.48461 8.64314 2.48461C11.9384 2.48461 14.6098 5.44447 14.6098 9.0957V9.64913L13.5077 8.42797L12.3024 9.76344L15.4622 13.2645L18.622 9.76344L17.4167 8.42797L16.3146 9.64913V9.0957C16.3146 4.40087 12.8803 0.595703 8.64314 0.595703C4.40591 0.595703 0.97168 4.40087 0.97168 9.0957C0.97168 13.7905 4.40591 17.5957 8.64314 17.5957C10.4561 17.5957 12.1251 16.8978 13.4386 15.7314L12.3723 14.2571C11.3503 15.1647 10.0546 15.7068 8.64314 15.7068C5.34782 15.7068 2.67645 12.7469 2.67645 9.0957ZM8.0318 7.15518V12.8735H9.7968V5.31794H8.21279L5.87033 6.78995L6.61495 8.10147L8.0318 7.15518Z",
    fill: "#FEC200"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPositionYellow);
export default __webpack_public_path__ + "static/media/positionYellow.f9861c30414c427d6595ac34c2abc2d4.svg";
export { ForwardRef as ReactComponent };